module.exports = __webpack_public_path__ + "img/elantra7.4381248e.jpeg";